import { render, staticRenderFns } from "./TransporterInformation.vue?vue&type=template&id=37dfcd22&scoped=true"
import script from "./TransporterInformation.vue?vue&type=script&lang=js"
export * from "./TransporterInformation.vue?vue&type=script&lang=js"
import style0 from "./TransporterInformation.vue?vue&type=style&index=0&id=37dfcd22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dfcd22",
  null
  
)

export default component.exports